export default {"src":"/_next/static/media/review-show-more.79d90455.svg","height":13,"width":16};